import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import axios from "../axios"
import Product from '../Product'
import ProductSkeleton from '../components/skeleton/ProductSkeleton'

const ProductCategory = () => {
    const [products,setProducts]=useState([])
    const params=useParams()
    useEffect(()=>{
        axios({
            url:'/products/get/products-by-category',
            method:'get',
            params:params.name
        })
        .then(res=>setProducts(res.data))
        .catch(err=>console.log(err))
    },[params.name])

  return (
    <div className='container-fluid' style={{minHeight:'80vh'}}> 
        <article className="row">  
                    {
                        products.length>0?
                        products.map((f,i)=>
                            <article className='col-md-3 col-sm-4' key={i}>
                            <Product
                            id={f._id}
                            title={f.title}
                            price={f.price}
                            rating={f.rating}
                            image={f.image}
                            stock={f.stock}
                            active={f.active}
                            />
                              </article>
                        ):
                        [...Array(4)].map((p,i)=>
                          <article className='col-md-3 col-sm-4' key={i}>
                              <ProductSkeleton />
                          </article>
                     )
                    }
            </article>
    </div>
  )
}

export default ProductCategory
